import styled from 'styled-components';

export const StyledSettingsIcon = styled.img`
  cursor: pointer;
`;
